var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedInfoOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.33398 6.0026H8.66732V4.66927H7.33398V6.0026ZM8.00065 13.3359C5.06065 13.3359 2.66732 10.9426 2.66732 8.0026C2.66732 5.0626 5.06065 2.66927 8.00065 2.66927C10.9406 2.66927 13.334 5.0626 13.334 8.0026C13.334 10.9426 10.9406 13.3359 8.00065 13.3359ZM8.00065 1.33594C7.12517 1.33594 6.25827 1.50838 5.44943 1.84341C4.64059 2.17844 3.90566 2.6695 3.28661 3.28856C2.03636 4.5388 1.33398 6.23449 1.33398 8.0026C1.33398 9.77071 2.03636 11.4664 3.28661 12.7166C3.90566 13.3357 4.64059 13.8268 5.44943 14.1618C6.25827 14.4968 7.12517 14.6693 8.00065 14.6693C9.76876 14.6693 11.4645 13.9669 12.7147 12.7166C13.9649 11.4664 14.6673 9.77071 14.6673 8.0026C14.6673 7.12712 14.4949 6.26022 14.1598 5.45138C13.8248 4.64254 13.3338 3.90762 12.7147 3.28856C12.0956 2.6695 11.3607 2.17844 10.5519 1.84341C9.74304 1.50838 8.87613 1.33594 8.00065 1.33594ZM7.33398 11.3359H8.66732V7.33594H7.33398V11.3359Z",
    fill: "#EF4444"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedInfoOutline);
export default __webpack_public_path__ + "static/media/red-info-outline.bcc206e7989589444ddd67d08611e192.svg";
export { ForwardRef as ReactComponent };